import React, { Component } from "react";
import Empty from "../../blocks/Empty";
import NavBottom from "../../blocks/NavBottom";

class NotFound extends Component {
  render() {
    return (
      // page 404
      <div>
        <Empty text={"صفحه ای پیدا نشد."} />
        <NavBottom />
      </div>
    );
  }
}

export default NotFound;
